class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.templateName = this.dataset.templateName;
    this.header = document.querySelector('.section-header');
    this.headerDrawer = document.querySelector('.menu-drawer-container')
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('.summary');
    this.modalContent = document.querySelector('.search-modal');
    this.modalOverlay = document.querySelector('.modal-overlay');
    this.searchInput = document.querySelector('.search__input')

    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.modalContent.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  connectedCallback() {

  }

  onSummaryClick(event) {
    event.preventDefault();
    // event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    this.summaryToggle.hasAttribute('open') ? this.close() : this.open(event, 200);
  }

  onBodyClick(event) {
    if (event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event, duration) {
    if(!this.header.classList.contains('header-active')) {
      this.header.classList.add('header-active');
    }
    //close header drawer
    this.headerDrawer.classList.remove('menu-opening');
    setTimeout(() => {
      this.headerDrawer.removeAttribute('open');
    })
    this.headerDrawer.querySelector('summary').setAttribute('aria-expanded', false);
    this.header.classList.add('header-bg-scroll-down-action');
    this.header.classList.remove('header-bg-scroll-up-action');
    this.header.classList.remove('header-bg-scroll-up');
    this.header.classList.remove('header-bg-scroll-down');
    this.header.classList.add('menu-open');
    this.modalOverlay.classList.add('modal-overlay-open')
    this.searchInput.focus();

    const length = this.searchInput.value.length;
    this.searchInput.setSelectionRange(length, length);

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    // event.target.closest('details').setAttribute('open', true);
    this.summaryToggle.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    // document.body.classList.add('overflow-hidden');
    this.modalContent.animate([
      { opacity: 0, transform: 'translateY(0rem)'},    // Fully visible
      { opacity: 1, transform: `translateY(${this.header.clientHeight}px)`}  // Fully hidden
    ], {
      duration: duration,
      easing: 'ease-out',
      fill: 'forwards'
    })
    // trapFocus(
      // this.detailsContainer.querySelector('[tabindex="-1"]'),
      // this.detailsContainer.querySelector('input:not([type="hidden"])')
    // );
  }

  close(focusToggle = true) {

    this.modalOverlay.classList.remove('modal-overlay-open')

    this.header.classList.remove('menu-open');
    this.header.classList.remove('header-active');
    if(!this.header.classList.contains('scrolled-past-header')) {
      this.header.classList.add('header-bg-scroll-up');
      this.header.classList.remove('header-bg-scroll-down');
    }
    this.header.classList.remove('header-bg-scroll-down-action');
    this.header.classList.remove('header-bg-scroll-up-action');
    // removeTrapFocus(focusToggle ? this.summaryToggle : null);
    // this.detailsContainer.removeAttribute('open');
    this.summaryToggle.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    // document.body.classList.remove('overflow-hidden');

    this.modalContent.animate([
      { opacity: 1, transform: `translateY(${this.header.clientHeight}px)`},    // Fully visible
      { opacity:0,  transform: 'translateY(0rem)'}  // Fully hidden
    ], {
      duration: 200,
      easing: 'ease-out',
      fill: 'forwards'
    }).onfinish = () => {
      // this.detailsContainer.removeAttribute('open');
    };
  }
}

customElements.define('details-modal', DetailsModal);